import React from 'react';
import MainMenu from '../MainMenu/MainMenu';

export default class Header extends React.Component {
  public render() {
    return (
      <header className="flex-1 h-14 mt-2 lg:mt-0 relative z-100 w-full lg:block lg:h-24">
        <MainMenu />
      </header>
    );
  }
}
